<template>
  <el-main class="reset-password">
    <img class="center-block logo" data-qa="Content-Logo-Image" src="/src/assets/img/admin-logo.png">
    <el-col :span="8" class="reset-form">
      <div class="title">{{ $t('resetFormTitle') }}</div>
      <div class="description">
        {{ $t('resetFormDescription') }}
      </div>
      <el-form @submit.native.prevent="validateForm">
        <el-form-item :error="errors.first('email')" :show-message="errors.has('email')" prop="email">
          <el-input @keyup.enter.native="validateForm" :placeholder="$t('resetInputEmailPlaceholder')" clearable data-qa="Content-ResetPasswordEmail-Input" name="email" type="text" v-model="email" v-validate="'required|email'">
            <i class="fa fa-envelope-open email" slot="prefix"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="validateForm" :disabled="loading || errors.any()" :loading="loading" data-qa="Content-ResetPassword-Button" id="signIn" type="primary">{{ $t('resetButtonSignInText') }}</el-button>
        </el-form-item>
      </el-form>
      <router-link class="go-back" data-qa="Content-ResetPasswordBack-Link" to="/login">{{ $t('resetLinkSignInText') }}</router-link>
    </el-col>
    <el-col :span="8" v-if="response">
      <el-card>
        <div data-qa="Content-ResetPasswordError-Title" slot="header">{{ $t('resetErrorResponseTitle') }}</div>
        <div data-qa="Content-ResetPasswordError-Body">{{ response }}</div>
      </el-card>
    </el-col>
  </el-main>
</template>

<script>
  import main from './ResetPassword.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './ResetPassword.scss'
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?00ad33ce